import styled from "@emotion/styled";
import { ChevronLeft } from "lucide-react";

export const StyleButtonIcon = styled(ChevronLeft)`
  transition: all 300ms ease-in-out;

  &:hover {
    scale: 1.1;
  }
  &:active {
    scale: 0.9;
  }
`
